export const crateModalActionTypes = {
  CRATE_RETURN: 0,
  CRATE_DETAILS: 1,
};
